import React from "react";

const Popover = ({ className, children, openPopover, setOpenPopover }) => {
  return (
    <>
      {openPopover && (
        <>
          <div className={`mono_popover_wrapper ${className}`}>{children}</div>
          <div
            className="backdrop"
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              background: "transparent",
              width: "100%",
              height: "100%",
              zIndex: "9999",
            }}
            onClick={() => setOpenPopover(false)}
          ></div>
        </>
      )}
    </>
  );
};

export default Popover;
